<template>
  <div>
    <div>
      <el-table
          ref="multipleTableRef"
          :data="pageDataList"
          style="width: 100%"
          border
          v-loading="listLoading"
          @cell-click="toggleSelection"
      >
        <el-table-column property="createTime" label="时间"/>
        <el-table-column property="" label="头像" width="120">
          <template #default="scope">
            <el-image style="width: 80px; height: 80px" :src="scope.row.headImg.smallHeadImg" @click="showImg(scope.row)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
          </template>
        </el-table-column>
        <el-table-column property="" label="用户">
          <template #default="scope">
            <p>昵称：{{ scope.row.nickName }}</p>
            <p>手机号：{{ scope.row.phone }}</p>
            <p>UID：{{ scope.row.uid }}</p>
          </template>
        </el-table-column>
        <el-table-column property="" label="信息">
          <template #default="scope">
            {{scope.row.sex === 1?'男':scope.row.sex === 2?'女': ''}} /
            {{scope.row.marryState === 1?'未婚':scope.row.marryState === 2?'离异': scope.row.marryState === 3?'丧偶':''}} /
            {{scope.row.age}}岁 /
            {{scope.row.height}}cm /
            {{scope.row.salaryMin === -1?'不限':scope.row.salaryMin}}-{{scope.row.salaryMax === -1?'不限':scope.row.salaryMax}}{{scope.row.salaryMax === -1?'':'k'}}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {throughCodeWeChatCopeUserInfo } from '@/api/url'
import { getFormData } from '@/api/api'
import Dialog from "@/assets/js/dialog";
import ImgViewer from '@/assets/js/imageViewer'


export default {
  name: "ThroughCodeCopyUserDialog",
  props: {
    value: Object
  },
  data() {
    return {
      id: this.value.id,
      time: this.value.time,

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,

    }
  },
  methods: {
    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },


    getPage() {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['id'] = this.id;
      param['time'] = this.time;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(throughCodeWeChatCopeUserInfo, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    showImg(row) {
      let imgList = []
      imgList.push(row.headImg.headImg)
      ImgViewer.open({
        imgList: imgList
      })
    },

    toggleSelection(row, column, cell, event) {
      //更新用户日志
      if(column.label == '被复制数量') {
        Dialog.open({
          title: '用户列表',
          component: MarriageCopyNumDialog,
          data: {
            id: row.id,
            width: '600px'
          },
          close: () => {

          }
        })
      }
    }


  },
  mounted() {
    this.getPage();
  }
}
</script>

<style scoped>

</style>
